import './TEventDialog.scss';

import Dialog from "../../1. Core/Controls/Dialog/Dialog";
import NP from "../../1. Core/NP";
import TextField from "../../1. Core/Controls/TextField/TextField";
import {ServerAPI} from "../../1. Core/ServerAPI";
import IconSelect from "../../1. Core/Controls/Select/IconSelect";
import {clearLocationsCache, getCountries, getLocations, getTournaments, ITournament} from "../Util";
import {EventTournament, Location, SportType} from "../types";
import DateInput from "../../1. Core/Controls/DateInput/DateInput";
import IconToggleButton from "../../1. Core/Controls/IconToggleButton/IconToggleButton";
import LocationListDialog from "../Library/Dialogs/LocationListDialog";
import TimeEdit, {TimeEditMode} from "../../1. Core/Controls/TimeEdit/TimeEdit";
import Select from "../../1. Core/Controls/Select/Select";
import {IState} from "../../2. Athletes/StatesList";
import Button from "../../1. Core/Controls/Button/Button";
import DataTable from "../../1. Core/Controls/DataTable/DataTable";


let moment = require('moment');

export default class TEventDialog extends Dialog {
    private _name: TextField;
    private _dateInput: DateInput;
    private _Date: Date;
    private _tournamentCombo: IconSelect;

    private _locationCombo: IconSelect;

    private _Event: EventTournament;
    private _addloCButton: IconToggleButton;
    private _timeInput: TimeEdit;
    private _Type: SportType;
    private _fileVideoPath: TextField;

    private _fullVideoHl: TextField;
    private _optimalVideoHl: TextField;
    private _shortlVideoP: TextField;
    private _videoStreamUrl: TextField;
    private _idValue: TextField;
    private _tvStreamBtn: Button;


    _initFields(settings: object) {
        this._Type = SportType.MMA;
        this._Event = null;
        super._initFields(settings);
        this._Mode = 'FullHeight';
        this._Caption = NP.RM.getString('Event');
        this._CloseOnFrameMouseDown = true;
        this._ShowHeader = true;
        this._ShowCloseButton = true;
        this._OkRK = 'Save'
        this._AutoDestroy = true;
        this._Width = 450;
    }

    _render() {
        super._render();

        this.addClass('t-event-dlg ')

        this._Date = new Date();


        this._name = new TextField({
            FloatingLabel: NP.RM.getString('Name'),
            ParentNode: this._contentNode
        });

        this._tournamentCombo = new IconSelect({
            ParentNode: this._contentNode,
            FloatingLabel: NP.RM.getString('Tournament')
        });

        this._dateInput = new DateInput({
            ParentNode: this._contentNode,
            FloatingLabel: NP.RM.getString('Date'),
            EvChanged: () => {
                this._Date = this._dateInput.getValue();
            }
        });

        this._idValue = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Id',
            EnableEdit: true
        });

        this._timeInput = new TimeEdit({
            ParentNode: this._contentNode,
            Mode: TimeEditMode.HoursMinutes,
            FloatingLabel: NP.RM.getString('UTCTime'),
        })

        this._videoStreamUrl = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: NP.RM.getString('VideoStreamUrl'),
        })

        this._fileVideoPath = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: NP.RM.getString('PathToVideoFile'),
        })

        this._fullVideoHl = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Event Highlight url'
        });

        this._optimalVideoHl = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Maincard Highlight url'
        });

        this._shortlVideoP = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: 'Prelims Highlight url'
        });

        this._locationCombo = new IconSelect({
            ParentNode: this._contentNode,
            FloatingLabel: NP.RM.getString('Location'),
            Width: 348
        });

        this._addloCButton = new IconToggleButton({
            FontImage: NP.FontImages.edit,
            Tooltip: NP.RM.getString('EditLocList'),
            ParentNode: this._contentNode,
            EvClick: () => {
                (new LocationListDialog({
                    EvClosed: () => this.updateLocations()
                })).show()
            }
        })

        this._addloCButton.getRoot().style.verticalAlign = 'bottom';
        this._addloCButton.getRoot().style.bottom = '9px'

        this._tvStreamBtn = new Button({
            ParentNode: this._contentNode,
            Content: 'TV/Stream',
            EvClick: () => {
                new TVStreamListDialog({
                    TVStreamData: this._Event.TVStreamUrl,
                    EvOkButtonClick: (dlg, args) => {
                        this._Event.TVStreamUrl = args.Value
                    }
                }).show()
            }
        });


        getTournaments(this._Type).then((res: ITournament[]) => {
            if (this._tournamentCombo) {
                let items = res.map(t => ({
                    Value: t.Id,
                    FontImage: NP.FontImages.integration,
                    Content: t.Name,
                    Data: t
                }));
                this._tournamentCombo.setItems(items);
                if (this._Event && this._Event.TournamentId)
                    this._tournamentCombo.setValue(this._Event.TournamentId)
            }
        });

        this.updateLocations();

        if (this._Event) {
            this._name.setValue(this._Event.Name)
            this._fileVideoPath.setValue(this._Event.VideoFilePath)
            this._idValue.setValue(this._Event.GloryEventID);

            this._fullVideoHl.setValue(this._Event.HLUrl_Full)
            this._optimalVideoHl.setValue(this._Event.HLUrl_Optimal)
            this._shortlVideoP.setValue(this._Event.HLUrl_Short)
            this._videoStreamUrl.setValue(this._Event.VideoStreamUrl)

            //this._tvStreamField.setValue(this._Event.TVStreamUrl)

            let date = moment(this._Event.Date)
            if (date.isValid()) {
                this._dateInput.setValue(date.toDate());
                this._timeInput.setValue(date.format('HH:mm'));
            }
        } else
            this._dateInput.setValue(new Date());
    }

    updateLocations() {
        clearLocationsCache();
        getLocations().then((res: Location[]) => {
            if (this._locationCombo) {
                let items = [
                    {Value: null, Content: ' ', FontImage: NP.FontImages.map},
                    ...res.map(t => ({Value: t.Id, FontImage: NP.FontImages.map, Content: t.Name}))
                ];


                this._locationCombo.setItems(items);
                if (this._Event && this._Event.LocationId)
                    this._locationCombo.setValue(this._Event.LocationId, false)
                else
                    this._locationCombo.setValue(null);
            }
        });
    }


    async _onOkButtonClick() {
        if (!this._name.getValue().trim() || !this._tournamentCombo.getValue())
            return;

        if (!this._Event)
            this._Event = {} as EventTournament;

        this._Event.GloryEventID = this._idValue.getValue();
        this._Event.Name = this._name.getValue().trim();
        this._Event.Date = moment(this._dateInput.getValue()).format('YYYY-MM-DD') + " " + this._timeInput.getValue() + ":00";
        this._Event.TournamentId = this._tournamentCombo.getValue();
        this._Event.LocationId = this._locationCombo.getValue();
        this._Event.VideoFilePath = this._fileVideoPath.getValue();
        this._Event.VideoStreamUrl = this._videoStreamUrl.getValue();

        //this._Event.TVStreamUrl = this._tvStreamField.getValue()


        this._Event.HLUrl_Full = this._fullVideoHl.getValue()
        this._Event.HLUrl_Optimal = this._optimalVideoHl.getValue()
        this._Event.HLUrl_Short = this._shortlVideoP.getValue()

        if (this._Event.Id)
            await ServerAPI.callUiApi(`/t-events/${this._Event.Id}`, this._Event, 'POST');
        else
            await ServerAPI.callUiApi('/t-events', this._Event, 'PUT')


        this.EvOkButtonClick.fire(this);
        this.hide();
    }
}


class TVStreamEditDialog extends Dialog {


    private _name: TextField;
    private _country: Select;
    private _TVStreamUrl: string;
    private _CountryId: null;


    _initFields(settings: object) {
        this._TVStreamUrl = null;
        this._CountryId = null;
        super._initFields(settings);
        this._Mode = 'FullHeight';
        this._Caption = 'Add TV/Stream';
        this._CloseOnFrameMouseDown = true;
        this._ShowHeader = true;
        this._ShowCloseButton = true;
        this._OkRK = 'Save'
        this._AutoDestroy = true;
    }

    _render() {
        super._render();

        this._name = new TextField({
            FloatingLabel: 'Url',
            ParentNode: this._contentNode,
            Value: this._TVStreamUrl
        });

        this._country = new Select({
            FloatingLabel: NP.RM.getString('Country'),
            ParentNode: this._contentNode
        });

        getCountries(true).then((res: IState[]) => {
            let items = res.map(state => ({Value: state.Id, FontImage: NP.FontImages.geo, Content: state.Name}));
            this._country.setItems(items);
            this._country.setValue(this._CountryId)
        })

        if (this._TVStreamUrl) {
            let btn = new Button({

                RK: 'Remove',
                EvClick: () => {
                    this.EvOkButtonClick.fire(this, {Remove: true});
                    this.hide();
                }
            })

            btn.putToNode(this._buttonsNode, this._cancelButton.getRoot())
        }
    }


    async _onOkButtonClick() {
        if (!this._name.getValue().trim() || !this._country.getValue())
            return;

        this.EvOkButtonClick.fire(this, {
            TVStreamUrl: this._name.getValue().trim(),
            CountryId: this._country.getValue()
        });
        this.hide();
    }
}


class TVStreamListDialog extends Dialog {

    private _dataTable: DataTable;
    private _TVStreamData: string;


    _initFields(settings: object) {
        this._TVStreamData = null;
        super._initFields(settings);
        this._Mode = 'FullHeight';
        this._Caption = 'TV/Stream'
        this._CloseOnFrameMouseDown = true;
        this._ShowHeader = true;
        this._ShowCloseButton = true;
        this._ShowButtons = true;
        this._OkRK = 'Save'
        this._AutoDestroy = true;
        this._Width = 850;
        this._ContentAutoFit = true;
    }

    _render() {
        super._render();
        this.addClass('nopad')

        let rows: TVStreamData[] = this._TVStreamData ? JSON.parse(this._TVStreamData) : [];


        this.setContent(this._dataTable = new DataTable({
            Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
            MultiSelect: false,
            ShowRowIndex: false,
            ImageWidth: 32,
            Columns: [{
                Content: 'TVStreamUrl',
                PropertyContent: 'TVStreamUrl',
                Width: '25%'
            }, {
                Content: 'CountryId',
                PropertyContent: 'CountryId',
                Width: '25%'
            }],
            ShowPaginator: false,
            EvItemClick: (s: object, e: { Item: TVStreamData }) => {
                new TVStreamEditDialog({
                    TVStreamUrl: e.Item.TVStreamUrl,
                    CountryId: e.Item.CountryId,
                    EvOkButtonClick: (s: object, args: any) => {
                        if (args.Remove) {
                            NP.removeFromArray(rows, e.Item)
                        } else {
                            e.Item.TVStreamUrl = args.TVStreamUrl;
                            e.Item.CountryId = args.CountryId;
                        }


                        this._dataTable.setRows(rows);
                    }
                }).show();
            }
        }));

        this._dataTable.setRows(rows);


        this._topAppBar.addItem(new IconToggleButton({
            FontImage: NP.FontImages.add,
            Tooltip: NP.RM.getString('Create'),
            EvClick: () => {
                new TVStreamEditDialog({
                    EvOkButtonClick: (s: object, e: any) => {
                        rows.push(e)
                        this._dataTable.setRows(rows);
                    }
                }).show();
            }
        }));
    }

    _onOkButtonClick() {

        this.EvOkButtonClick.fire(this, {Value: JSON.stringify(this._dataTable.getRows())});
        this.hide()
    }

}

interface TVStreamData {
    TVStreamUrl: string;
    CountryId: string;
}
